import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../components/forms/input'

const AddIngredient = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = async () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({ nameEmpty: '食材名称不能为空' })
      return false
    }

    try {
      const response = await axios.post('/admin/content/basic_ingredient/add', {
        name: formValue.name,
        calorie: Number(formValue.calorie),
        carbohydrate: Number(formValue.carbohydrate),
        protein: Number(formValue.protein),
        calcium: Number(formValue.calcium),
        potassium: Number(formValue.potassium),
        dietary_fiber: Number(formValue.dietary_fiber)
      })

      if (response.errcode === 0) {
        message.success('添加成功！')
        props.getIngredientData()
        return true
      } else if (response.errcode === 1) {
        setErrorMsg({ nameRepeatError: response.msg })
        return false
      }
    } catch (error) {
      console.error('请求失败，错误信息为：', error)
      return false
    }
  }

  const handleOk = async () => {
    const isOk = await handleSubmit()
    if (isOk !== false) {
      handleCancel()
    }
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <Modal
      destroyOnClose={true}
      title="添加食材"
      width='500px'
      open={props.isOpen}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key='cancel' onClick={handleCancel}>取消</Button>,
        <Button key='submit' onClick={handleNext}>提交并添加下一条</Button>,
        <Button key='isOk' type="primary" onClick={handleOk}>添加</Button>
      ]}>
      
      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='食材名称'
        placeholder='请输入'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty || errorMsg.nameRepeatError}
      />

      <MyInput
        type='number'
        id="calorie"
        maxLength={64}
        label='热量(kcal)'
        value={formValue.calorie}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="carbohydrate"
        maxLength={64}
        label='碳水化合物(g)'
        value={formValue.carbohydrate}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="protein"
        maxLength={64}
        label='蛋白质(g)'
        value={formValue.protein}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="fat"
        maxLength={64}
        label='脂肪(g)'
        value={formValue.fat}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="moisture"
        maxLength={64}
        label='水分(g)'
        value={formValue.moisture}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="potassium"
        maxLength={64}
        label='钾(mg)'
        value={formValue.potassium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
        controls={false}
      />

      <MyInput
        type='number'
        id="sodium"
        maxLength={64}
        label='钠(mg)'
        value={formValue.sodium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="calcium"
        maxLength={64}
        label='钙(mg)'
        value={formValue.calcium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="magnesium"
        maxLength={64}
        label='镁(mg)'
        value={formValue.magnesium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="iron"
        maxLength={64}
        label='铁(mg)'
        value={formValue.iron}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="phosphorus"
        maxLength={64}
        label='磷(mg)'
        value={formValue.phosphorus}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default AddIngredient
